export default __webpack_public_path__ + "static/media/magnet-field-therapy.c9a9c09e.jpg";